import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const UserTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchDistrictData = async () => {
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("moduleId", M_id);

      const result = await fetchFormData("user/list", formData, "POST");

      if (result) {
        const user = result.users;
        setUserData(user || []);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      Swal.close(); // hide loader
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const result = await fetchFormData(
      `user/toggle-status/${Id}`,
      formData,
      "POST"
    );

    if (result && result.code === 200) {
      await fetchDistrictData();
      if (result && result.status === 1) {
        topTost({
          title: "Status updated successfully : Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully : Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle status:", result.message);
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/employee/edit-employee/${id}?id=${M_id}`)
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}

                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),

    {
      accessorKey: "name",
      header: () => "Employee name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "phone",
      header: () => "Phone",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "role",
      header: () => "Role",
      cell: (info) => (
        <span className="badge bg-warning text-white text-capitalize">
          {info.getValue()}
        </span>
      ),
      defaultIsVisible: true,
    },
    {
      accessorKey: "branch_name",
      header: () => "Branch name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "email",
      header: () => "Email",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "alternet_contact",
      header: () => "Alternate contact",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "address",
      header: () => "Address",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "state_name",
      header: () => "State",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "district_name",
      header: () => "District",
      cell: (info) => info.getValue(),
    },
    {
      accessorKey: "city_name",
      header: () => "City",
      cell: (info) => info.getValue(),
    },
     {
      accessorKey: "employ_Id",
      header: () => "Employ id",
      cell: (info) => info.getValue(),
    },
  ];

  useEffect(() => {
    fetchDistrictData();
  }, []);
  return (
    <>
      <Table data={userData} columns={columns} />
    </>
  );
};

export default UserTable;
